<template>
  <div class="jl-account-info-wrap">
    <div class="jl-acc-info-box">
      <div class="item-main">
        <p class="text-title">基本信息</p>
        <div class="main-box">
          <div class="main-top">
            <p class="text1">订单编号：{{ auctionInfo.id }}</p>
            <p class="text2 success" v-if="auctionInfo.orderStatus === 1">
              待发货
            </p>
            <p class="text2 error" v-else-if="auctionInfo.orderStatus === 2">
              未支付
            </p>
            <p class="text2 error" v-else-if="auctionInfo.orderStatus === 0">
              已逾期
            </p>
            <p class="text2 error" v-else-if="auctionInfo.orderStatus === 3">
              已发货
            </p>
          </div>
          <div class="main-contetn">
            <template v-if="auctionInfo.orderGoodsType === 0">
              <div class="fl-ground">
                <p class="text3 alt-label">拍品名称</p>
                <p class="text3">{{ auctionInfo.auction.name }}</p>
              </div>
              <div class="fl-ground">
                <p class="text3 alt-label">拍卖类型</p>
                <p class="text3">
                  {{
                    auctionInfo.bid.bidType == 1 ? '普通价拍卖' : '秒杀价拍卖'
                  }}
                </p>
              </div>
              <div class="fl-ground" v-if="detailType">
                <p class="text3 alt-label">应付金额</p>
                <p class="text3">￥ {{ auctionInfo.order.orderPrice }}</p>
              </div>
              <div class="fl-ground" v-else>
                <p class="text3 alt-label">起拍价</p>
                <p class="text3">
                  ￥ {{ auctionInfo.tauctionNper.startPrice }}
                </p>
              </div>
            </template>
            <template v-if="auctionInfo.orderGoodsType === 1">
              <div class="fl-ground">
                <div class="order-product">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>商品消息</th>
                        <th>单价</th>
                        <th>数量</th>
                        <th>实付</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(item, index) in shopList">
                        <tr :key="'order-d-' + index">
                          <td>
                            <div class="item-left">
                              <!-- <div class="item-l-img">
                              <img :src="item.image" alt>
                              </div>-->
                              <div class="item-l-box">
                                <p class="text2">{{ item.name }}</p>
                              </div>
                            </div>
                          </td>
                          <td>
                            <p class="text1">￥ {{ item.price }}</p>
                          </td>
                          <td>
                            <p class="text1 col-black">{{ item.number }}</p>
                          </td>
                          <td>
                            <p class="text1 col-black">
                              ￥ {{ item.totalPrice }}
                            </p>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
            </template>

            <div class="fl-ground">
              <p class="text3 alt-label">订单金额</p>
              <p class="text3">￥ {{ auctionInfo.orderPrice }}</p>
            </div>
            <div
              class="fl-ground"
              v-if="
                auctionInfo.receiveWay != undefined ||
                  auctionInfo.receiveWay != null
              "
            >
              <p class="text3 alt-label">收货方式</p>
              <p class="text3">
                {{ auctionInfo.receiveWay == 1 ? '快递' : '自提' }}
              </p>
            </div>
            <div
              class="fl-ground"
              v-if="
                auctionInfo.payMethod != undefined ||
                  auctionInfo.payMethod != null
              "
            >
              <p class="text3 alt-label">付款方式</p>
              <p class="text3" v-if="auctionInfo.payMethod === 0">在线支付</p>
              <p class="text3" v-if="auctionInfo.payMethod === 1">货到付款</p>
              <p class="text3" v-if="auctionInfo.payMethod === 2">微信转账</p>
            </div>
            <div class="fl-ground">
              <p class="text3 alt-label">用户名</p>
              <p class="text3">{{ userInfo.userName }}</p>
            </div>
            <div class="fl-ground">
              <p class="text3 alt-label">绑定手机号</p>
              <p class="text3">{{ userInfo.phone }}</p>
            </div>
            <div class="fl-ground">
              <p class="text3 alt-label">账单到期时间</p>
              <p class="text3">{{ auctionInfo.dueTime }}</p>
            </div>
            <div class="fl-ground" v-if="auctionInfo.payTime">
              <p class="text3 alt-label">支付时间</p>
              <p class="text3">{{ auctionInfo.payTime }}</p>
            </div>
          </div>
        </div>
        <div class="main-footer clearfix">
          <div class="main-footer-box">
            <div class="order-price-info">
              <span class="span-1">订单金额：</span>
              <span class="span-1 col-red">￥</span>
              <span class="span-1 col-red alt-price">{{
                auctionInfo.orderPrice
              }}</span>
            </div>

            <div
              v-if="
                auctionInfo.payMethod == undefined ||
                  auctionInfo.payMethod == null ||
                  auctionInfo.receiveWay == undefined ||
                  auctionInfo.receiveWay == null
              "
              class="order-pay-btn"
              @click="pay"
            >
              立即支付
            </div>

            <div
              v-if="
                auctionInfo.orderStatus === 2 &&
                  auctionInfo.receiveWay == 1 &&
                  auctionInfo.payMethod != 2
              "
              class="order-pay-btn"
              @click="pay"
            >
              立即支付
            </div>
          </div>
        </div>
      </div>
      <div class="item-right">
        <div class="right-box">
          <p class="text-title">物流明细</p>
          <div v-if="hasWl" class="text-info-wrap">
            <p class="text-status">
              {{ auctionInfo.logisticsNumber ? '已发货' : '未发货' }}
            </p>
            <div class="right-cont1">
              <p class="text1" v-if="auctionInfo.logisticsName">
                {{ auctionInfo.logisticsName }}
              </p>
              <p class="text2" v-if="auctionInfo.logisticsNumber">
                单号: {{ auctionInfo.logisticsNumber }}
              </p>
            </div>
            <div class="right-info">
              <p class="r-info-title">收货信息</p>
              <div class="fl-ground">
                <p class="text-1 alt-1">收货人</p>
                <p class="text-1">
                  {{ auctionInfo.logisticsAddress.consignee }}
                </p>
              </div>
              <div class="fl-ground">
                <p class="text-1 alt-1">联系方式</p>
                <p class="text-1">
                  {{ auctionInfo.logisticsAddress.contactPhone }}
                </p>
              </div>
              <div class="fl-ground">
                <p class="text-1 alt-1">收货地址</p>
                <p class="text-1">
                  {{ auctionInfo.logisticsAddress.shippingAddress }}
                </p>
              </div>
              <div class="fl-ground">
                <p class="text-1 alt-1">邮编</p>
                <p class="text-1">{{ auctionInfo.logisticsAddress.zipCode }}</p>
              </div>
              <div class="fl-ground">
                <p class="text-1 alt-1">备注</p>
                <p class="text-1">{{ auctionInfo.remark }}</p>
              </div>
            </div>
          </div>
          <div v-else class="text-none-info">
            <div class="text-none-info-box">
              <img src="../../../assets/img/zkj-none-more-info.png" alt />
              <p class="text-none">暂无更多信息</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { orderDetail } from '../../../api/order';
export default {
  name: 'accountAuctionDetail',
  computed: {
    ...mapGetters(['userInfo'])
  },
  data() {
    const orderId = this.$route.params.id;
    return {
      payType: false, // false => 未支付
      detailType: false, // false => 没有生成订单的拍品
      auctionInfo: {},
      shopList: [],
      orderId: orderId,
      hasWl: false
    };
  },
  methods: {
    pay() {
      // orderGoodsType  0:拍品  1：商品
      if (this.auctionInfo.orderGoodsType === 0) {
        var list = [
          {
            goods: {
              name: this.auctionInfo.auction.name,
              auctionId: this.auctionInfo.auctionId
            },
            image:
              this.comImgUrl + this.auctionInfo.auction.imgsUrl.split('|')[0],
            goodsId: this.auctionInfo.auctionId,
            totalPrice: this.auctionInfo.orderPrice,
            price: this.auctionInfo.orderPrice,
            total: 1
          }
        ];
        var data = {
          totalPrice: parseFloat(this.auctionInfo.orderPrice),
          waitPaidPrice: this.auctionInfo.waitPaidPrice,
          list: list
        };
        this.$store.dispatch('saveCartItemData', data);
      }

      if (this.auctionInfo.orderGoodsType === 0) {
        //拍品订单
        if (this.auctionInfo.logisticsAddressId) {
          this.$router.push({
            name: 'orderPay',
            params: {
              id: this.orderId,
              orderGoodsType: this.auctionInfo.orderGoodsType
            }
          });
        } else {
          this.$router.push({
            path:
              this.auctionInfo.orderGoodsType === 0
                ? '/auction/detail/order'
                : '/shop/detail/order',
            query: {
              id: this.orderId,
              orderGoodsType: this.auctionInfo.orderGoodsType
            }
          });
        }
      } else if (this.auctionInfo.orderGoodsType === 1) {
        //商品订单
        this.$router.push({
          name: 'orderPay',
          params: {
            id: this.orderId,
            orderGoodsType: this.auctionInfo.orderGoodsType
          }
        });
      }
    }
  },
  created() {
    orderDetail(this);
  }
};
</script>

<style lang="scss" scoped>
.jl-acc-info-box {
  position: relative;
  padding-right: 300px;
  &.no-has-wl {
    padding-right: 0;
  }
  .item-main {
    position: relative;
    z-index: 10;
    background: #fff;
    min-height: 450px;
    padding: 25px 50px;
    box-shadow: 9px 0 14px rgba($color: #b8b8b8, $alpha: 0.1);
    .text-title {
      font-size: 18px;
      color: #333;
      margin-bottom: 20px;
    }
    .main-box {
      padding: 20px;
      background: #f8f8fb;
    }
    .main-top {
      position: relative;
      padding-bottom: 20px;
      border-bottom: 1px solid #e0e0e0;
      .text1 {
        font-size: 14px;
        color: #333;
      }
      .text2 {
        position: absolute;
        right: 5px;
        top: 0;
        font-size: 14px;

        padding-left: 16px;
        &.success {
          color: #007af4;
          &::before {
            background: #007af4;
          }
        }
        &.error {
          color: #e50011;
          &::before {
            background: #e50011;
          }
        }
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          width: 6px;
          height: 6px;
          border-radius: 3px;
          margin-top: -3px;
        }
      }
    }
    .main-contetn {
      padding-top: 20px;
      .fl-ground {
        margin-bottom: 20px;
        &:last-child {
          margin-bottom: 0;
        }
        .text3 {
          display: inline-block;
          vertical-align: middle;
          font-size: 14px;
          color: #333;
          &.alt-label {
            color: #666;
            width: 120px;
          }
        }
      }
    }
    .main-footer-box {
      float: right;
      margin-top: 16px;
      .order-price-info {
        display: inline-block;
        .span-1 {
          display: inline-block;
          font-size: 14px;
          color: #666;
          &.col-red {
            color: #e70819;
          }
          &.alt-price {
            font-size: 24px;
            margin-left: 5px;
          }
        }
      }
      .order-pay-btn {
        display: inline-block;
        width: 156px;
        height: 42px;
        line-height: 42px;
        color: #fff;
        text-align: center;
        background: #e50011;
        margin-left: 25px;
        cursor: pointer;
      }
    }
  }
  .item-right {
    position: absolute;
    right: 0;
    top: 0;
    width: 300px;
    height: 100%;
    background: #fff;
    padding-left: 18px;
    .right-box {
      padding: 0 16px;
      .text-title {
        font-size: 18px;
        color: #333;
        padding-top: 25px;
        padding-bottom: 20px;
        border-bottom: 1px solid #e0e0e0;
        margin-bottom: 20px;
      }
      .text-status {
        position: relative;
        font-size: 24px;
        color: #12a624;
        padding-left: 20px;
        margin-bottom: 24px;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 50%;
          width: 8px;
          height: 8px;
          background: #12a624;
          border-radius: 4px;
          margin-top: -4px;
        }
      }
      .right-cont1 {
        margin-bottom: 30px;
        .text1 {
          font-size: 18px;
          color: #333;
          line-height: 30px;
        }
        .text2 {
          font-size: 14px;
          color: #666;
        }
      }
      .right-info {
        .r-info-title {
          font-size: 18px;
          color: #333;
          margin-bottom: 10px;
        }
        .fl-ground {
          position: relative;
          padding-left: 72px;
          margin-bottom: 12px;
          height: 20px;
          .text-1 {
            font-size: 14px;
            color: #333;
            line-height: 20px;
            &.alt-1 {
              position: absolute;
              left: 0;
              top: 0;
            }
          }
        }
      }
      .text-none-info-box {
        margin-top: 130px;
        text-align: center;
        .text-none {
          font-size: 14px;
          color: #666;
          margin-top: 18px;
        }
      }
    }
  }
}

.order-product {
  .table {
    width: 100%;
    max-width: 100%;
    border-spacing: 0;
    border-collapse: collapse;
    border: 1px solid #e0e0e0;
    thead {
      background: #f6f6f6;
      border-bottom: 1px solid #e0e0e0;
    }
    th {
      font-size: 14px;
      color: #666;
      font-weight: 500;
      padding: 3px 0;
      text-align: center;
      width: 17.5%;
      &:first-child {
        padding-left: 20px;
        text-align: left;
        width: 47.5%;
      }
    }
    tbody {
      td {
        text-align: center;
        &:first-child {
          text-align: left;
        }
      }
      .text1 {
        font-size: 14px;
        color: #666;
        &.col-black {
          color: #333;
          font-weight: bold;
        }
      }
      .item-left {
        padding: 3px 0 3px 0;
        .item-l-img {
          display: table-cell;
          vertical-align: middle;
          overflow: hidden;
          width: 80px;
          height: 105px;
          line-height: 105px;
        }
        img {
          display: block;
          max-height: 100%;
          max-width: 100%;
        }
      }
      .item-l-box {
        display: table-cell;
        vertical-align: middle;
        padding-left: 20px;
        .text2 {
          font-size: 16px;
          color: #333;
          line-height: 30px;
        }
        .text3 {
          font-size: 14px;
          color: #666;
          line-height: 30px;
        }
      }
      tr {
        border-bottom: 1px solid #e0e0e0;
        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
